import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import { getAllMenus } from '../../../services/navigation';
import NavItem from './NavItem';
import { AuthStore } from '../../../providers/auth';

const SideNavBar: React.FC<{ isOpen?: boolean }> = ({ isOpen = false }) => {
  const [, , logout, selectedPersona] = useContext(AuthStore) || [];
  const [open, setOpen] = useState(isOpen);
  const [activeMenu, setActiveMenu] = useState<number>();

  const navigate = useNavigate();
  const menuList = getAllMenus(selectedPersona);

  const handleToggle = (event: React.MouseEvent) => {
    !open && event.preventDefault();
    setOpen((prevOpen) => !prevOpen);
  };

  const closeOnClickOutside = () => {
    setOpen(false);
    isOpen = false;
  };

  useEffect(() => {
    if (isOpen) {
      setOpen(true);
    }
  }, [isOpen]);

  return (
    <Fragment>
      <div
        className={`menu-overlay ${open ? 'open' : ''}`}
        onClick={closeOnClickOutside}
      ></div>
      <Nav
        className={`cnd-sidebar-navigation d-flex flex-column position-fixed top-0 start-0 h-100 ${
          open ? 'open' : ''
        }`}
      >
        <div>
          <div
            className={'px-7 pt-7 pb-7 logo-wrapper-mobile d-lg-none'}
            onClick={() => navigate('/dashboard')}
          >
            <img
              src={`${process.env.PUBLIC_URL}/logo.png`}
              alt="conduent-logo"
              height={48}
            />
          </div>
          <div
            className={'navigation-toggle px-9 py-12 d-none d-lg-block'}
            onClick={handleToggle}
          >
            <FontAwesomeIcon icon={light('bars')} />
          </div>
        </div>
        <div className={'navigation-list'}>
          {menuList.map((menu: any, index: number) => (
            <NavItem
              key={index}
              menuData={menu}
              isMainMenuOpen={open}
              setMainMenuOpen={setOpen}
              isActive={activeMenu === index}
              onToogle={(e: any) =>
                setActiveMenu((active) => (active === index ? -1 : index))
              }
            />
          ))}
        </div>
        <div
          className={'user-wrapper d-flex align-items-center px-9 py-7'}
          onClick={() => {
            logout();
          }}
        >
          <FontAwesomeIcon icon={light('power-off')} />
          <span className={'link-name'}>Logout</span>
        </div>
      </Nav>
    </Fragment>
  );
};

export default SideNavBar;
